module.exports = __webpack_public_path__ + "static/media/e-disbursements.357c51c1.svg";